import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { TokenContext } from "../app/App";
import { getAllTopItems, ResponseStatus, TopItemsData, Track } from "../spotify/spotify";
import RecapInfo from "./RecapInfo";

const Tool: React.FC = () => {
    //const [ token, setToken ] = useState<AccessTokenDto | null>(null);
    const { token, setToken } = useContext(TokenContext);
    const [ searchParams, _setSearchParams ] = useSearchParams();
    const [ status, setStatus ] = useState<"loaded" | "loading" | "success" | "error">("loading");
    const [ topItemsData, setTopItemsData ] = useState<TopItemsData | null>(null);

    const collectTopItems = async (accessToken: string) => {
        setStatus("loading");
        const topItemsData = await getAllTopItems(accessToken);
        if (topItemsData === ResponseStatus.Unauthorized || topItemsData === ResponseStatus.UnknownError) {
            setStatus("error");
            return;
        }
        setTopItemsData(topItemsData);
        setStatus("loaded");
    }
    
    useEffect(() => {
        const accessToken = searchParams.get("accessToken");
        const refreshToken = searchParams.get("refreshToken");
        const expiresIn = searchParams.get("expiresIn");
        const now = searchParams.get("now");

        if (!accessToken || !refreshToken || !expiresIn || isNaN(parseInt(expiresIn)) || !now || isNaN(parseInt(now))) {
            setStatus("error");
            return;
        }

        setToken({accessToken, refreshToken, expiresIn: parseInt(expiresIn) });
        setStatus("loaded");
        collectTopItems(accessToken);
    }, [ searchParams ]);

    return (
        <div className="w-screen column-centered py-10">
            { 
                status === "loading" && 
                <div className="flex flex-col items-center mt-20">
                    <div className="loading-ellipsis"><div></div><div></div><div></div><div></div></div>
                    <p className="text-center">Collecting Top Items...</p>
                </div>
            }
            { 
                status === "error" && 
                <>
                    <p>An unknown error occurred.</p> 
                    <Link to="/" className="my-4">Home</Link>
                </>
            }
            { 
                status === "loaded" && topItemsData &&
                <RecapInfo topItemsData={topItemsData} />
            }
        </div>
    );
}

export default Tool;
